
export class styleReqFilter {
    styleNo?: string[]
    season?: string;
    year?: string;
    styleId?:string;
}